// import { ContentfulClient } from 'react-contentful';
export const version = '2.10.2';
export const navbarBreakPoint = 'xl'; // Vertical navbar breakpoint
export const topNavbarBreakpoint = 'lg';
export const settings = {
  isFluid: false,
  isRTL: false,
  isDark: false,
  isTopNav: false,
  isVertical: true,
  get isCombo() {
    return this.isVertical && this.isTopNav;
  },
  showBurgerMenu: false, // controls showing vertical nav on mobile
  currency: '$',
  isNavbarVerticalCollapsed: false,
  navbarStyle: 'transparent'
};
export default { version, navbarBreakPoint, topNavbarBreakpoint, settings };

const REACT_APP_API_GATEWAY_URL = process.env.REACT_APP_API_GATEWAY_URL;
const REACT_APP_OPEN_API_GATEWAY_URL = process.env.REACT_APP_OPEN_API_GATEWAY_URL;

const REACT_APP_CONTENTFUL_AUTH_SPACE_ID = process.env.REACT_APP_CONTENTFUL_AUTH_SPACE_ID;
const REACT_APP_CONTENTFUL_AUTH_ACCESS_TOKEN = process.env.REACT_APP_CONTENTFUL_AUTH_ACCESS_TOKEN;

export const aws = {
  s3: {
    REGION: 'us-east-1'
  },
  apiGateway: {
    REGION: 'us-east-1',
    URL: REACT_APP_API_GATEWAY_URL
  },
  openApiGateway: {
    REGION: 'us-east-1',
    URL: REACT_APP_OPEN_API_GATEWAY_URL
  },
  oddApiGateway: {
    URL: 'https://69zsek7c6j.execute-api.us-east-1.amazonaws.com/marketing/'
    // URL: process.env.ODD_API_GATEWAY_URL
  },
  devOddApiGateway: {
    URL: 'https://bjmz5wiiv0.execute-api.us-east-1.amazonaws.com/dev/'
  },
  cognito: {
    loginUrl: process.env.REACT_APP_LOGIN_URL
  }
};

// const CONTENTFUL_ACCESS_TOKEN = process.env.CONTENTFUL_ACCESS_TOKEN;
// const CONTENTFUL_SPACE_ID = process.env.CONTENTFUL_SPACE_ID;

export const contentful = {
  space: REACT_APP_CONTENTFUL_AUTH_SPACE_ID,
  token: REACT_APP_CONTENTFUL_AUTH_ACCESS_TOKEN
};
